module.exports = __webpack_public_path__ + "media/images/brand/img-fusic-guideline-6393bde8109f7545ea3cc8972b3b2e1f.png";